/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { SearchMyPaymentRequests200ResponseInnerRequestor } from './search-my-payment-requests200-response-inner-requestor';
// May contain unused imports in some cases
// @ts-ignore
import { SearchMyPaymentRequests200ResponseInnerSupplier } from './search-my-payment-requests200-response-inner-supplier';

/**
 * 
 * @export
 * @interface SearchMyPaymentRequests200ResponseInner
 */
export interface SearchMyPaymentRequests200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInner
     */
    'serialNumber': string;
    /**
     * 
     * @type {SearchMyPaymentRequests200ResponseInnerSupplier}
     * @memberof SearchMyPaymentRequests200ResponseInner
     */
    'supplier': SearchMyPaymentRequests200ResponseInnerSupplier;
    /**
     * 
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInner
     */
    'dueDate': string;
    /**
     * 
     * @type {number}
     * @memberof SearchMyPaymentRequests200ResponseInner
     */
    'totalAmount': number;
    /**
     * 
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInner
     */
    'transferFeeResponsibility': SearchMyPaymentRequests200ResponseInnerTransferFeeResponsibilityEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInner
     */
    'memo': string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInner
     */
    'withholdingCalculatingMethod': SearchMyPaymentRequests200ResponseInnerWithholdingCalculatingMethodEnum;
    /**
     * 
     * @type {number}
     * @memberof SearchMyPaymentRequests200ResponseInner
     */
    'withholdingAmount': number | null;
    /**
     * 
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInner
     */
    'status': SearchMyPaymentRequests200ResponseInnerStatusEnum;
    /**
     * 
     * @type {SearchMyPaymentRequests200ResponseInnerRequestor}
     * @memberof SearchMyPaymentRequests200ResponseInner
     */
    'requestor': SearchMyPaymentRequests200ResponseInnerRequestor;
    /**
     * requestorName is the name of the requesting user at the time this PaymentRequest was requested. The free word search targets the name of requesting user, but it is the requestorName that is targeted, not the name of the user at the time of the search. Use requestor.name if you want to know what is the name at present of the user.
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInner
     */
    'requestorName': string;
    /**
     * 
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInner
     */
    'requestedAt': string;
    /**
     * If bank transfer data has already been created, return the ID. Otherwise, null.
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInner
     */
    'bankTransferId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInner
     */
    'invoiceEvidenceId': string;
}

export const SearchMyPaymentRequests200ResponseInnerTransferFeeResponsibilityEnum = {
    self: 'SELF',
    supplier: 'SUPPLIER'
} as const;

export type SearchMyPaymentRequests200ResponseInnerTransferFeeResponsibilityEnum = typeof SearchMyPaymentRequests200ResponseInnerTransferFeeResponsibilityEnum[keyof typeof SearchMyPaymentRequests200ResponseInnerTransferFeeResponsibilityEnum];
export const SearchMyPaymentRequests200ResponseInnerWithholdingCalculatingMethodEnum = {
    none: 'NONE',
    manuscriptOrLecture: 'MANUSCRIPT_OR_LECTURE',
    lawyerOrCpa: 'LAWYER_OR_CPA',
    judicialScrivener: 'JUDICIAL_SCRIVENER',
    other: 'OTHER'
} as const;

export type SearchMyPaymentRequests200ResponseInnerWithholdingCalculatingMethodEnum = typeof SearchMyPaymentRequests200ResponseInnerWithholdingCalculatingMethodEnum[keyof typeof SearchMyPaymentRequests200ResponseInnerWithholdingCalculatingMethodEnum];
export const SearchMyPaymentRequests200ResponseInnerStatusEnum = {
    pendingWorkflowCompletion: 'PENDING_WORKFLOW_COMPLETION',
    canceled: 'CANCELED',
    payable: 'PAYABLE',
    attachedToBankTransfer: 'ATTACHED_TO_BANK_TRANSFER',
    deactivated: 'DEACTIVATED'
} as const;

export type SearchMyPaymentRequests200ResponseInnerStatusEnum = typeof SearchMyPaymentRequests200ResponseInnerStatusEnum[keyof typeof SearchMyPaymentRequests200ResponseInnerStatusEnum];


